import { css } from '@emotion/core'

/**
 * 統計カード用のユーティリティ関数とスタイル定義
 */

// trend判定ロジック
export const getTrend = (momRate?: number): 'up' | 'down' | 'keep' => {
  if (momRate === undefined || momRate === 0) {
    return 'keep'
  }
  return momRate > 0 ? 'up' : 'down'
}

// trendColor決定ロジック
export const getTrendColor = (trend: 'up' | 'down' | 'keep'): string => {
  switch (trend) {
    case 'up':
      return '#185AA5'
    case 'down':
      return '#E6483B'
    case 'keep':
      return '#676767'
  }
}

// 共通のスタイル定義
export const cardStyle = css({
  padding: '20px',
  background: '#fff',
  borderRadius: '4px',
  border: '1px solid #D9D9D9',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
})

export const titleStyle = css({
  fontSize: '14px',
  color: '#A3A3A3',
  marginBottom: '8px',
  textAlign: 'center',
})

export const valueContainerStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  paddingTop: '12px',
})

export const prevMonthContainerStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '8px',
  flex: 1,
  textAlign: 'center',
})

export const arrowStyle = css({
  fontSize: '24px',
  lineHeight: 1,
})

export const prevMonthInfoStyle = css({
  fontSize: '12px',
  lineHeight: 1.4,
})

export const currentMonthValueStyle = css({
  fontSize: '32px',
  fontWeight: 'bold',
  color: '#272727',
  flex: 1,
  textAlign: 'center',
})
